import script from "./FeedBackCreate.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeedBackCreate.vue?vue&type=script&setup=true&lang=ts"

import "./FeedBackCreate.vue?vue&type=style&index=0&id=34769ce8&lang=scss"

const __exports__ = script;

export default __exports__